import { Search } from 'lucide-react';

import { ListDetailGroup, ListDetailRow } from '@/ui/ListDetail';
import { formatUtcDate } from '@/ui/format';

import { byYear, type Release } from './releaseIndex';

/** The search field and the live "N of M releases" count that sit above the list. */
export function ReleaseSearch({
  text,
  onText,
  shown,
  total,
}: {
  text: string;
  onText: (text: string) => void;
  shown: number;
  total: number;
}) {
  return (
    <>
      <div className="search-field">
        <Search aria-hidden="true" />
        <input
          type="search"
          value={text}
          placeholder="Search releases"
          aria-label="Search releases"
          onChange={(e) => onText(e.target.value)}
        />
      </div>
      <p className="hint" aria-live="polite">
        {shown} of {total} releases
      </p>
    </>
  );
}

/** The `ListDetail` rows: releases under a heading per year, the selected one current, the running one marked. */
export function releaseRows({
  releases,
  selected,
  running,
  onSelect,
}: {
  releases: readonly Release[];
  selected: string | undefined;
  running: string;
  onSelect: (version: string) => void;
}) {
  if (releases.length === 0) return <li className="hint">No release matches</li>;
  return byYear(releases).map(({ year, releases: group }) => [
    <ListDetailGroup key={year}>
      {year} ({group.length})
    </ListDetailGroup>,
    ...group.map((release) => {
      const when = release.date ? formatUtcDate(release.date) : '';
      const secondary = [when, release.highlight].filter(Boolean).join(' · ');
      return (
        <ListDetailRow
          key={release.version}
          primary={`Version ${release.version}`}
          secondary={secondary}
          trailing={release.version === running ? 'Running' : undefined}
          title={secondary}
          selected={release.version === selected}
          onSelect={() => onSelect(release.version)}
        />
      );
    }),
  ]);
}
